/*
 * A culture's area in mm², for reading beside the cm² it is measured and stored
 * in (culture_analyses.*_area_cm2): a display only, with no column of its own.
 */
export function cm2ToMm2(cm2) {
  if (cm2 === null || cm2 === undefined || cm2 === '') return null;
  const value = Number(cm2);
  return Number.isFinite(value) ? value * 100 : null;
}

/** "6.250 cm² · 625.0 mm²": two fewer decimals in mm², so both say the same precision. */
export function bothAreas(cm2, digits, { fmt, cm2Unit, mm2Unit }) {
  const mm2 = cm2ToMm2(cm2);
  const first = `${fmt(cm2, digits)} ${cm2Unit}`;
  return mm2 === null ? first : `${first} · ${fmt(mm2, Math.max(0, digits - 2))} ${mm2Unit}`;
}
